import React, { useEffect, useState } from 'react'
import {Badge, Button, ImageBuffer, Loader, SubHeader} from '../'
import { LinkRounded } from '@mui/icons-material'
import { AppDispatch, RootState } from '../../reducers/store'
import { useDispatch, useSelector } from 'react-redux'
import { actionFetchPosts } from '../../actions/posts'
import { emptyDisplay } from '../../assets'
import './projects.css'

const Projects = () => {
  const dispatch                        = useDispatch<AppDispatch>();
  const [loadMoreData, setLoadMoreData] = useState(false);
  const [loadLessData, setLoadLessData] = useState(false);
  const {isLoading, getAllPosts}        = useSelector((state: RootState) => state?.postList)
  const [projects, setProjects]         = useState(getAllPosts)
  const displayCount                    = 4;
  const [visible, setVisible]           = useState(displayCount);
  
  useEffect(() => {
    setProjects(getAllPosts)
  }, [getAllPosts]);

  useEffect(() => {
    dispatch(actionFetchPosts());
  }, [dispatch]);

  const loadMoreBtn = () => {
    setLoadMoreData(true)

    setTimeout(() => {
      setVisible((prev) => prev + displayCount);
      setLoadMoreData(false);
    }, 1000);
  }
  const loadLessBtn = () => {
    setLoadLessData(true)

    setTimeout(() => {
    setVisible((prev) => prev - displayCount);
    setLoadLessData(false);
  }, 1000);
  }

  return (
    <>
      <section id='projects' className='projects-main-wrapper'>
        <Badge title="Projects" />
        <SubHeader title="" description="My completed projects as a full-stack developer highlight my ability to deliver complete end-to-end solutions, combining strong functionality with thoughtful design to create seamless and engaging user experiences." />

        <div className='projects-box-container'>
          {isLoading ? <Loader /> : (
            projects.slice(0, visible).map((result, index) => {
            const postImage = `${process.env.REACT_APP_BACKEND_POSTS_IMAGE_URL}${result?.selectedFile}` || emptyDisplay;
            return (
              <div key={index} className="projects-box">
                <div className="projects-box-main-cover">
                  <div className="projects-box-cover">
                    <div className="projects-box-main">
                      <ImageBuffer src={postImage} alt={`${result?.title}`} />
                    </div>

                    <div className="projects-box-sub">
                      {result?.description}
                    </div>
                  </div>
                </div>

                <p className="project-title">{result.title}</p>
                <a href={result.link} className="project-link" target='_blank'><LinkRounded />View Project</a>
              </div>
            )})
          )}
        </div>
        
        <div className='projects-box-btn'>
        {visible < projects.length && (
          <Button 
            onClickButton 
            onClickNavigate={loadMoreBtn} 
            buttonClickWrap={loadMoreData ? `button-login-submitted` : `button-login-submit`}
            onClickName={loadMoreData ? <>{<Loader />} Loading...</> : "See More"}
          />
        )}

        {visible > displayCount && (
          <Button
            onClickButton
            onClickNavigate={loadLessBtn}
            buttonClickWrap={loadLessData ? `button-login-submitted` : `button-login-submit`}
            onClickName={loadLessData ? <>{<Loader />} Loading...</> : "See Less"}
          />
        )}
        </div>
      </section>
    </>
  )
}

export default Projects